export const resolvePersonnelName = (personnel, userId) => {
  if (userId == null) return '';
  if (Array.isArray(personnel)) {
    const match = personnel.find((entry) => `${entry?.id ?? entry?.userId}` === `${userId}`);
    return match?.name || match?.fullName || match?.username || '';
  }
  if (personnel && typeof personnel === 'object') {
    const direct = personnel[userId] ?? personnel[`${userId}`];
    return direct?.name || direct?.fullName || direct?.username || '';
  }
  return '';
};
